import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { useDebounce } from '../../hooks/useDebounce'

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001'

export const TableList = ({ handleOpen, searchTerm, updateTrigger }) => {
  const [tableData, setTableData] = useState([])
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)
  const debouncedSearchTerm = useDebounce(searchTerm, 500) // 500ms de delay

  const fetchData = async () => {
    setLoading(true)
    try {
      const response = await axios.get(`${API_URL}/api/clients`)
      setTableData(response.data)
    } catch (error) {
      setError(error.message)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, [updateTrigger])

  // Filter the table data based on the debounced searchTerm
  const filteredData = tableData.filter(
    (client) => {
      // console.log('Termo de busca atual:', debouncedSearchTerm) // Log do termo de busca
      return (
        (client.name?.toLowerCase() || '').includes(debouncedSearchTerm.toLowerCase()) ||
        (client.email?.toLowerCase() || '').includes(debouncedSearchTerm.toLowerCase()) ||
        (client.job?.toLowerCase() || '').includes(debouncedSearchTerm.toLowerCase())
      )
    }
  )

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      'Are you sure you want to delete this client? This action cannot be undone.',
    )
    if (confirmDelete) {
      try {
        await axios.delete(`${API_URL}/api/clients/${id}`)
        setTableData((prevData) =>
          prevData.filter((client) => client.id !== id),
        )
      } catch (error) {
        setError(error.message)
        console.error('Error deleting client:', error)
      }
    }
  }

  return (
    <>
      {error && <div className="alert alert-error">{error}</div>}
      {loading ? (
        <div className="flex justify-center items-center h-40">
          <span className="loading loading-spinner loading-lg"></span>
          <span className="ml-4 text-xl">Carregando...</span>
        </div>
      ) : (
        <div className="overflow-x-auto mt-10">
          <table className="table">
            {/* head */}
            <thead>
              <tr>
                <th></th>
                <th>Name</th>
                <th>Email</th>
                <th>Job</th>
                <th>Rate</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody className="hover">
              {/* row 1 */}
              {filteredData.map((client, index) => (
                <tr key={client.id || index}>
                  <th>{index + 1}</th>
                  <td>{client.name}</td>
                  <td>{client.email}</td>
                  <td>{client.job}</td>
                  <td>{client.rate}</td>
                  <td>
                    <button
                      className={`btn btn-sm rounded-full w-20 ${
                        client.isactive ? 'btn-primary' : 'btn-outline'
                      }`}
                    >
                      {client.isactive ? 'Ativo' : 'Inativo'}
                    </button>
                  </td>
                  <td>
                    <button
                      onClick={() => handleOpen('edit', client)}
                      className={`btn btn-secondary`}
                    >
                      Update
                    </button>
                  </td>
                  <td>
                    <button
                      className={`btn btn-accent`}
                      onClick={() => handleDelete(client.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
        <div className='flex justify-center mt-20 text-3xl'>
          <h1>Este banco de dados por segurança ira reiniciar após 2 minutos todas as configurações ao Padrão</h1>
        </div>
    </>
  )
}
